export default __webpack_public_path__ + "static/media/grafema_2ndliferesin_16.c0833492.jpg";